<template>
<div class="tree-img">
  <img :src="getImgUrl()" />
</div>
</template>

<script>
export default {
  props: {
    percent: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      imageIndex:1,
    };
  },
  methods: {
    getImgUrl() {
       this.imageIndex = Math.floor(this.percent * 11)+1;
      return require("@/assets/trees/" + this.imageIndex + ".png");
    }
  }
};
</script>

<style>
.tree-img{
  height: 100px;
    width: 100px;
    text-align: center;
    position: absolute;
    right: 0;
}
.tree-img img{
  height: 100%;

}
</style>
